import { GenericResource, IHttpAgent } from '@sparelabs/http-client-utils'
import {
  ICaseTypeObjectLinkPatchBody,
  ICaseTypeObjectLinkPostBody,
  ICaseTypeObjectLinkResponse,
  IListCaseTypeObjectLinkQueryParams,
} from '../types'
import { Resources } from './ResourcesType'

export class CaseTypeObjectLinkResource extends GenericResource<
  ICaseTypeObjectLinkResponse,
  IListCaseTypeObjectLinkQueryParams,
  ICaseTypeObjectLinkPatchBody,
  ICaseTypeObjectLinkPostBody
> {
  public get = async (linkId: string, params: { id: string }) => {
    const resourcePath = this.resource.replace(':id', params.id)
    const res = await this.agent.get<ICaseTypeObjectLinkResponse>(`${resourcePath}/${linkId}`)
    return res.data
  }

  // Override list to handle path parameter
  public list = async (params: { id: string }) => {
    const { id, ...queryParams } = params
    const resourcePath = this.resource.replace(':id', id)

    const { data } = await this.agent.get<{
      data: ICaseTypeObjectLinkResponse[]
      total: number
      skip: number
      limit: number
    }>(resourcePath, { params: queryParams })
    return data
  }

  // Override post to handle path parameter
  public post = async (body: ICaseTypeObjectLinkPostBody, params: { id: string }) => {
    const resourcePath = this.resource.replace(':id', params.id)
    const res = await this.agent.post<ICaseTypeObjectLinkResponse>(resourcePath, body)
    return res.data
  }

  // Override patch to handle path parameter
  public patch = async (linkId: string, body: ICaseTypeObjectLinkPatchBody, params: { id: string }) => {
    const resourcePath = this.resource.replace(':id', params.id)
    const res = await this.agent.patch<ICaseTypeObjectLinkResponse>(`${resourcePath}/${linkId}`, body)
    return res.data
  }

  // Override delete to handle path parameter
  public delete = async (linkId: string, params: { id: string }) => {
    const resourcePath = this.resource.replace(':id', params.id)
    await this.agent.delete(`${resourcePath}/${linkId}`)
  }

  constructor(agent: IHttpAgent) {
    super(Resources.CaseTypeObjectLinks, agent)
  }
}
